// src/stores/forecast/forecastSelectors.ts
import { ForecastStore } from "./forecastTypes";

// Selection / workflow
export const selectSelectedTypeWell = (s: ForecastStore) => s.selectedTypeWell;
export const selectHasUnsavedChanges = (s: ForecastStore) => s.hasUnsavedChanges;
export const selectIsCreatingTypeWell = (s: ForecastStore) => s.isCreatingTypeWell;
export const selectTemporaryForecast = (s: ForecastStore) => s.temporaryForecast;
export const selectSyncStateType = (s: ForecastStore) => s.syncState.type;
export const selectSyncStateId = (s: ForecastStore) => s.syncState.id;

// Global selections
export const selectCheckedGlobalForecasts = (s: ForecastStore) =>
  s.checkedGlobalForecasts;
export const selectCheckedGlobalTypeWells = (s: ForecastStore) =>
  s.checkedGlobalTypeWells;
export const selectOriginalCheckedGlobalTypeWells = (s: ForecastStore) =>
  s.originalCheckedGlobalTypeWells;

// Local widget selections
export const selectCheckedForecasts = (s: ForecastStore) => s.checkedForecasts;
export const selectCheckedTypeWells = (s: ForecastStore) => s.checkedTypeWells;
export const selectCheckedForecastKeys = (s: ForecastStore) => s.checkedForecastKeys;
export const selectCheckedTypeWellKeys = (s: ForecastStore) => s.checkedTypeWellKeys;

// Tree expansion
export const selectExpandedForecastKeys = (s: ForecastStore) => s.expandedForecastKeys;
export const selectExpandedTypeWellKeys = (s: ForecastStore) => s.expandedTypeWellKeys;

// Special folder toggles
export const selectUseMcDanielForecasts = (s: ForecastStore) => s.useMcDanielForecasts;
export const selectUseNoviForecasts = (s: ForecastStore) => s.useNoviForecasts;
export const selectUseWorkingForecasts = (s: ForecastStore) => s.useWorkingForecasts;

// Save/validation flags
export const selectIsTypeWellSavable = (s: ForecastStore) => s.isTypeWellSavable;
export const selectHasWellDataError = (s: ForecastStore) => s.hasWellDataError;
export const selectHasTypeWellSaveSucceeded = (s: ForecastStore) =>
  s.hasTypeWellSaveSucceeded;

// Chart drag overlay
export const selectBEditableSegments = (s: ForecastStore) => s.bEditableSegments;
export const selectTypeWellTemplateNames = (s: ForecastStore) => s.typeWellTemplateNames;

// NOTE: No folder data selectors — forecastFolders / typeWellFolders are in React Query.
// Consumers call useForecastFolderFetcher() directly; filtered lists are derived at call sites.
